import { render, staticRenderFns } from "./FavoriteStar.vue?vue&type=template&id=62295ba8&scoped=true&"
import script from "./FavoriteStar.vue?vue&type=script&lang=ts&"
export * from "./FavoriteStar.vue?vue&type=script&lang=ts&"
import style0 from "./FavoriteStar.vue?vue&type=style&index=0&id=62295ba8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62295ba8",
  null
  
)

export default component.exports